// Calculate midpoint between two points
export const calculateMidpoint = (point1, point2) => {
  return [
    (point1[0] + point2[0]) / 2,
    (point1[1] + point2[1]) / 2
  ];
};

// Format distance display
export const formatDistance = (distance) => {
  if (distance < 1) {
    return `${(distance * 1000).toFixed(0)}m`;
  }
  return `${distance.toFixed(2)}km`;
};

// Convert degrees to radians
export const toRad = (x) => {
  return x * Math.PI / 180;
};

// Calculate Manhattan distance between two points
export const manhattanDistance = (lat1, lon1, lat2, lon2) => {
  // Convert degree differences to approximate kilometers
  const latDiff = Math.abs(lat2 - lat1);
  const lonDiff = Math.abs(lon2 - lon1);
  
  // Convert to kilometers using degree-to-km conversion
  const latKm = latDiff * 111.0;
  const lonKm = lonDiff * 111.0;
  
  // Manhattan distance in kilometers
  return latKm + lonKm;
};

// Calculate total distance of entire path
export const calculatePathDistance = (path, locations) => {
  if (!path || path.length < 2 || !locations || locations.length === 0) {
    return 0;
  }
  
  let totalDistance = 0;
  
  for (let i = 0; i < path.length - 1; i++) {
    const current = locations.find(loc => loc.id === path[i]);
    const next = locations.find(loc => loc.id === path[i + 1]);
    
    if (current && next) {
      totalDistance += manhattanDistance(
        current.latitude, 
        current.longitude, 
        next.latitude, 
        next.longitude
      );
    }
  }
  
  return totalDistance;
};

export const safeSetSourceData = (map, mapReady, sourcesReady, sourceId, data) => {
  if (!map || !mapReady || !sourcesReady) return false;
  
  try {
    const source = map.getSource(sourceId);
    if (source) {
      source.setData(data);
      return true;
    }
  } catch (err) {
    console.error(`Error updating data source ${sourceId}:`, err);
  }
  return false;
}; 